import { CommonAppRouteId as CommonAppRouteId } from "../enums/common-app-route-id";
import { IAppRouterService } from "../interfaces/app-router-service";
import { AbstractRouterService } from "./abstract-router.service";
import { Injectable } from "@angular/core";
import { APP_FEATURE_GROUP_ID } from "../constants/app-constants";

/**
 * Abstract Class for the AppRouterService
 *
 * AppRouterService handles root navigation in the application and powers the side nav
 *
 * R is the Enum for the Route ids for the App
 */

@Injectable()
export abstract class AbstractAppRouterService<R extends string> extends AbstractRouterService<R | CommonAppRouteId>
    implements IAppRouterService<R> {

    /**
     * Returns true if the error page is currently loaded
     */
    get isError(): boolean {

        return this.isRouteActive(CommonAppRouteId.Error);
    }

    /**
     * Default constructor the featureGroupId will be set to the APP_FEATURE_GROUP_ID
     */
    constructor() {
        super(APP_FEATURE_GROUP_ID);
    }

    /**
     * Navigate to the root of the application
     */
    toRoot(): void {
        this._navigateByRouteId(CommonAppRouteId.Root);
    }

    /**
     * Navigate to the Error page
     */
    toError(): void {
        this._navigateByRouteId(CommonAppRouteId.Error);
    }

}
